export default "__VITE_ASSET__CPIeQMJI__"